import { SanityAnnualReturnsTable, SanityAnnualReturnsTableData } from 'types/annual-returns';
import { AnnualReturnsTableData } from '@sanity/graphql/queries/annual-returns-table-data';
import { useQueryWithContext } from '@utils/villus';

export async function getAnnualReturnsTableData(context?: string): Promise<SanityAnnualReturnsTable | null> {
	const { data } = await useQueryWithContext<SanityAnnualReturnsTableData>({
		query: AnnualReturnsTableData,
		baseTag: 'annual_returns_table_data',
		contextTag: context
	}).execute();

	return data?.allAnnualReturnsTable[0] ?? null;
}
